/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Support_ChatInputs */

const en_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Support Chat`)
};

const fr_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat de support en direct`)
};

const de_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Support-Chat`)
};

const it_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat di supporto in tempo reale`)
};

const ru_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чат онлайн-поддержки`)
};

const es_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat de soporte en vivo`)
};

const zh_cn2_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线客服聊天`)
};

const ja_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブサポートチャット`)
};

const hi_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव सपोर्ट चैट`)
};

const pt_pt2_live_support_chat = /** @type {(inputs: Live_Support_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat de suporte ao vivo`)
};

/**
* | output |
* | --- |
* | "Live Support Chat" |
*
* @param {Live_Support_ChatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_support_chat = /** @type {((inputs?: Live_Support_ChatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Support_ChatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_support_chat(inputs)
	if (locale === "de") return de_live_support_chat(inputs)
	if (locale === "it") return it_live_support_chat(inputs)
	if (locale === "ru") return ru_live_support_chat(inputs)
	if (locale === "es") return es_live_support_chat(inputs)
	if (locale === "zh-CN") return zh_cn2_live_support_chat(inputs)
	if (locale === "ja") return ja_live_support_chat(inputs)
	if (locale === "hi") return hi_live_support_chat(inputs)
	if (locale === "pt-PT") return pt_pt2_live_support_chat(inputs)
	return en_live_support_chat(inputs)
});